import React, { useState, Fragment, useMemo } from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import Form, { RequiredMessage } from "assets/scripts/components/common/form/Form/Form";
import noop from "lodash/noop";
import ProfileNameInputs, { getErrors as getNameErrors } from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileNameInputs/ProfileNameInputs";
import MiniMiranda from "assets/scripts/components/presentational/MiniMiranda/MiniMiranda";
import ProfileOkEmailInput, { getErrors as getOkEmailErrors } from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileOkEmailInput/ProfileOkEmailInput";
import ProfileAddressInputs, { getErrors as getAddressErrors } from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileAddressInputs/ProfileAddressInputs";
import ProfilePhoneInputs, { getErrors as getPhoneErrors } from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfilePhoneInputs/ProfilePhoneInputs";
import PasswordCreateInputs, { getErrors as getPasswordErrors } from "assets/scripts/components/forms/public/PasswordCreateInputs/PasswordCreateInputs";
import { showAuthorized, showRelationship } from "./registrationUtils";
import Intro from "./Intro/Intro";
import AuthorizedInput, { getErrors as getAuthorizedErrors } from "assets/scripts/components/forms/public/AuthorizedInput/AuthorizedInput";
import EmailAndRelationshipInputs, { getErrors as getEmailAndRelationshipErrors } from "assets/scripts/components/forms/public/EmailAndRelationshipInputs/EmailAndRelationshipInputs";
import ProfileLanguageInputs, { getErrors as getLanguageErrors, } from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageInputs";
// tslint:disable-next-line:max-line-length
import ProfileLanguageChange from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageChange";
// tslint:disable-next-line:max-line-length
import ProfileLanguageOther from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageOther";
// tslint:disable-next-line:max-line-length
import ProfileLanguageExit from "assets/scripts/components/forms/secure/profile/ProfileForm/ProfileLanguageInputs/ProfileLanguageExit";
import { Requirements } from "../PasswordForgot";
import { Link } from "react-router";
import { confirm, confirmValidation, newAccount, setupSession } from "api/accounts";
import { apiService } from "assets/scripts/domain/apiService";
import AuthorizedPerson from "./AuthorizedPerson/AuthorizedPerson";
import AuthorizedPersonInput from "assets/scripts/components/forms/public/AuthorizedPersonInput/AuthorizedPersonInput";
import { findAuthorizedId } from "assets/scripts/domain/validation/utils";
import ValidationFieldset from "assets/scripts/components/common/form/ValidtationFieldset/ValidationFieldset";
import { getValidationErrors } from "assets/scripts/components/forms/public/AccountValidationForm/AccountValidationForm";
import { formatValidationData } from "assets/scripts/domain/validation/dataConversion";
import mapBackendErrors from "assets/scripts/utils/mapBackendErrors";
import { fieldErrorsBackToFront } from "assets/scripts/domain/misc/dataConversion";
import StatusMessage from "assets/scripts/components/presentational/StatusMessage";
import { VALIDATION, PROFILE } from "assets/scripts/constants/StatusMessages";
import { create } from "api/profile";
import { rightPartyContact } from "api/accounts";
import { registrationComplete } from "assets/scripts/domain/validation/validationActions";
import { connect } from "react-redux";
import styles from "./Registration.module.less";
import StepProgress from "./StepProgress/StepProgress";
import useRouting from "assets/scripts/hooks/useRouting";
import track from "react-tracking";
import { RegistrationChannel } from "assets/scripts/domain/validation/validationModels";
var Step;
(function (Step) {
    Step[Step["Intro"] = 0] = "Intro";
    Step[Step["Name"] = 1] = "Name";
    Step[Step["AuthorizedName"] = 2] = "AuthorizedName";
    Step[Step["MiniMiranda"] = 3] = "MiniMiranda";
    Step[Step["ValidationQuestions"] = 4] = "ValidationQuestions";
    Step[Step["EmailAndRelationship"] = 5] = "EmailAndRelationship";
    Step[Step["EmailConsent"] = 6] = "EmailConsent";
    Step[Step["Address"] = 7] = "Address";
    Step[Step["Phone"] = 8] = "Phone";
    Step[Step["Language"] = 9] = "Language";
    Step[Step["LanguageChange"] = 10] = "LanguageChange";
    Step[Step["LanguageOther"] = 11] = "LanguageOther";
    Step[Step["LanguageExit"] = 12] = "LanguageExit";
    Step[Step["SecurityQuestionAndPassword"] = 13] = "SecurityQuestionAndPassword";
})(Step || (Step = {}));
function showValidationStep(validationQuestions) {
    return validationQuestions.length > 0;
}
const STEP_ORDER = [
    Step.Name,
    Step.MiniMiranda,
    Step.ValidationQuestions,
    Step.EmailAndRelationship,
    Step.EmailConsent,
    Step.Address,
    Step.Language,
    Step.Phone,
    Step.SecurityQuestionAndPassword
];
const NYC_ZIPS = [
    "10001", "10002", "10003", "10004", "10005", "10006", "10007", "10008", "10009", "10010",
    "10011", "10012", "10013", "10014", "10015", "10016", "10017", "10018", "10019", "10020",
    "10021", "10022", "10023", "10024", "10025", "10026", "10027", "10028", "10029", "10030",
    "10031", "10032", "10033", "10034", "10035", "10036", "10037", "10038", "10039", "10040",
    "10041", "10043", "10044", "10045", "10046", "10047", "10048", "10055", "10060", "10065",
    "10069", "10072", "10075", "10079", "10080", "10081", "10082", "10087", "10090", "10094",
    "10095", "10096", "10098", "10099", "10101", "10102", "10103", "10104", "10105", "10106",
    "10107", "10108", "10109", "10110", "10111", "10112", "10113", "10114", "10115", "10116",
    "10117", "10118", "10119", "10120", "10121", "10122", "10123", "10124", "10125", "10126",
    "10128", "10129", "10130", "10131", "10132", "10133", "10138", "10149", "10150", "10151",
    "10152", "10153", "10154", "10155", "10156", "10157", "10158", "10159", "10160", "10161",
    "10162", "10163", "10164", "10165", "10166", "10167", "10168", "10169", "10170", "10171",
    "10172", "10173", "10174", "10175", "10176", "10177", "10178", "10179", "10184", "10185",
    "10196", "10197", "10199", "10200", "10203", "10211", "10212", "10213", "10242", "10249",
    "10256", "10257", "10258", "10259", "10260", "10261", "10265", "10268", "10269", "10270",
    "10271", "10272", "10273", "10274", "10275", "10276", "10277", "10278", "10279", "10280",
    "10281", "10282", "10285", "10286", "10292", "10301", "10302", "10303", "10304", "10305",
    "10306", "10307", "10308", "10309", "10310", "10311", "10312", "10314", "10451", "10452",
    "10453", "10454", "10455", "10456", "10457", "10458", "10459", "10460", "10461", "10462",
    "10463", "10464", "10465", "10466", "10467", "10468", "10469", "10470", "10471", "10472",
    "10473", "10474", "10475", "11001", "11003", "11004", "11005", "11040", "11101", "11102",
    "11103", "11104", "11105", "11106", "11109", "11201", "11203", "11204", "11205", "11206",
    "11207", "11208", "11209", "11210", "11211", "11212", "11213", "11214", "11215", "11216",
    "11217", "11218", "11219", "11220", "11221", "11222", "11223", "11224", "11225", "11226",
    "11228", "11229", "11230", "11231", "11232", "11233", "11234", "11235", "11236", "11237",
    "11238", "11239", "11241", "11242", "11243", "11249", "11252", "11256", "11351", "11354",
    "11355", "11356", "11357", "11358", "11359", "11360", "11361", "11362", "11363", "11364",
    "11365", "11366", "11367", "11368", "11369", "11370", "11371", "11372", "11373", "11374",
    "11375", "11377", "11378", "11379", "11385", "11411", "11412", "11413", "11414", "11415",
    "11416", "11417", "11418", "11419", "11420", "11421", "11422", "11423", "11424", "11425",
    "11426", "11427", "11428", "11429", "11430", "11432", "11433", "11434", "11435", "11436",
    "11437", "11439", "11451", "11690", "11691", "11692", "11693", "11694", "11695", "11697",
    "10313", "11202", "11245", "11247", "11251", "11352", "11380", "11381", "11386", "11431"
];
function isNYCZip(value) {
    return NYC_ZIPS.includes((value.zip || "").trim());
}
const messages = defineMessages({
    submit: {
        id: "registration.submit",
        defaultMessage: "Create Profile"
    },
    submitNext: {
        id: "registration.submitNext",
        defaultMessage: "Next"
    }
});
function InfoHeader() {
    return (<div className="vr vr_x2 text">
			<FormattedMessage tagName="p" id="registration.provideInfo" defaultMessage="Please provide us some information about you."/>
		</div>);
}
export function RegistrationBase(props) {
    const { deceased } = props;
    const { push } = useRouting();
    const [step, setStep] = useState(Step.Intro);
    const [validationError, setValidationError] = useState(null);
    const [profileError, setProfileError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [validationFieldErrors, setValidationFieldErrors] = useState([]);
    const [profileFieldErrors, setProfileFieldErrors] = useState([]);
    const { globalError, backendErrors } = mapBackendErrors(validationFieldErrors.length === 0 ? profileFieldErrors : validationFieldErrors);
    const [value, setValue] = useState({
        authorized: !showAuthorized(deceased),
        firstName: "",
        lastName: "",
        email: props.emailAddress || "",
        relationship: showRelationship(deceased) ? props.relationship || "" : "Self",
        okEmail: null,
        validation: {},
        address: "",
        address2: "",
        city: "",
        state: "",
        zip: "",
        phoneHome: "",
        phoneCell: "",
        phoneWork: "",
        phoneWorkExt: "",
        preferredPhone: "Unspecified",
        securityQuestion: "",
        securityAnswer: "",
        password: "",
        passwordConfirm: "",
        authorizedId: null,
        languagePreference: null
    });
    const stepProgress = useMemo(() => {
        let curStep = step;
        let countOffset = 0;
        if (curStep === Step.AuthorizedName) {
            countOffset = countOffset + 0.5;
            curStep = Step.Name;
        }
        if (curStep === Step.LanguageChange
            || curStep === Step.LanguageExit
            || curStep === Step.LanguageOther) {
            curStep = Step.Language;
        }
        let steps = STEP_ORDER;
        if (!showValidationStep(props.validationQuestions)) {
            steps = steps.filter(it => it !== Step.ValidationQuestions);
        }
        if (!isNYCZip(value)) {
            steps = steps.filter(it => it !== Step.Language);
        }
        const current = steps.indexOf(curStep);
        if (current == null) {
            throw new Error("Unexpected state");
        }
        return {
            current: current + countOffset,
            total: steps.length
        };
    }, [step, props.validationQuestions, value]);
    const handleUpdate = (update) => setValue({
        ...value,
        ...update
    });
    const handlePreEmailConfirmation = async (nextStep) => {
        setValidationError(null);
        setLoading(true);
        let response;
        try {
            response = await confirmValidation({
                attestation: value.authorized,
                authorizedId: value.authorizedId === -1 ? null : value.authorizedId,
                confirmation: formatValidationData(value.validation),
                decedentRelationship: null,
                pin: props.pin,
                referenceNumber: props.referenceNumber
            });
        }
        catch (error) {
            setValidationError(error);
            setLoading(false);
            return;
        }
        if (response.data.success) {
            setValidationFieldErrors([]);
            // prepopulate profile address, if available
            const address = response.data.data;
            handleUpdate({
                address: address.address || "",
                address2: address.address2,
                city: address.city || "",
                state: address.stateProvince || "",
                zip: address.postalCode || ""
            });
            setStep(nextStep);
        }
        else {
            setValidationFieldErrors(fieldErrorsBackToFront(response.data.errors));
        }
        setLoading(false);
    };
    let content = null;
    let isValid = false;
    let showRequired = true;
    let handleSubmit = noop;
    let submitLabel = messages.submitNext;
    switch (step) {
        case Step.Intro: {
            const errors = getAuthorizedErrors(value, deceased);
            isValid = Object.values(errors).every(it => it == null);
            showRequired = showAuthorized(deceased);
            handleSubmit = () => setStep(Step.Name);
            content = (<Fragment>
					<Intro deceased={deceased} decedent={props.decedent}/>

					<AuthorizedInput deceased={deceased} value={value} errors={errors} backendErrors={backendErrors} onChange={handleUpdate}/>
				</Fragment>);
            break;
        }
        case Step.Name: {
            const errors = getNameErrors(value);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = () => {
                setStep(value.authorizedId == null ? Step.AuthorizedName : Step.MiniMiranda);
            };
            content = (<Fragment>
					<InfoHeader />
					<ProfileNameInputs value={value} errors={errors} backendErrors={backendErrors} onChange={update => {
                handleUpdate({
                    ...update,
                    authorizedId: findAuthorizedId(update.firstName, update.lastName, props.authIndividuals)
                });
            }}/>
				</Fragment>);
            break;
        }
        case Step.AuthorizedName: {
            isValid = value.authorizedId != null;
            handleSubmit = async () => {
                if (showValidationStep(props.validationQuestions)) {
                    setStep(Step.MiniMiranda);
                }
                else {
                    await handlePreEmailConfirmation(Step.MiniMiranda);
                }
            };
            content = (<AuthorizedPerson inModal={false}>
					<AuthorizedPersonInput authId={value.authorizedId} authIndividuals={props.authIndividuals} onChange={authorizedId => handleUpdate({ authorizedId })}/>
				</AuthorizedPerson>);
            break;
        }
        case Step.MiniMiranda: {
            isValid = true;
            showRequired = false;
            handleSubmit = () => setStep(showValidationStep(props.validationQuestions) ? Step.ValidationQuestions : Step.EmailAndRelationship);
            content = (<div className="vr vr_x5">
					<div className="text">
						{deceased && (<FormattedMessage tagName="p" id="profileCreate.intro1" defaultMessage={"Please note: In your capacity as the person who is authorized to act on "
                + "behalf of the estate, you are not personally liable for such bills."}/>)}

						<MiniMiranda />
					</div>
				</div>);
            break;
        }
        case Step.ValidationQuestions: {
            const errors = getValidationErrors(value, props.validationQuestions);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = async () => {
                await handlePreEmailConfirmation(Step.EmailAndRelationship);
            };
            content = (<ValidationFieldset value={value.validation} onChange={validation => handleUpdate({ validation })} errors={errors} requirements={props.validationQuestions} locale={props.locale} showLegend={false}/>);
            break;
        }
        case Step.EmailAndRelationship: {
            const errors = getEmailAndRelationshipErrors(value, deceased);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = async () => {
                if (!value.relationship) {
                    throw new Error("Unexpected state");
                }
                setLoading(true);
                setValidationError(null);
                let response;
                try {
                    response = await confirm({
                        attestation: value.authorized,
                        authorizedId: value.authorizedId === -1 ? null : value.authorizedId,
                        confirmation: formatValidationData(value.validation),
                        decedentRelationship: value.relationship,
                        emailAddress: value.email,
                        pin: props.pin,
                        referenceNumber: props.referenceNumber
                    });
                }
                catch (error) {
                    setValidationError(error);
                    setLoading(false);
                    return;
                }
                if (response.data.success) {
                    setValidationFieldErrors([]);
                    setStep(Step.EmailConsent);
                }
                else {
                    setValidationFieldErrors(fieldErrorsBackToFront(response.data.errors));
                }
                setLoading(false);
            };
            content = (<Fragment>
					<InfoHeader />
					<EmailAndRelationshipInputs deceased={deceased} value={value} errors={errors} backendErrors={backendErrors} onChange={handleUpdate}/>
				</Fragment>);
            break;
        }
        case Step.EmailConsent: {
            showRequired = false;
            const errors = getOkEmailErrors(value);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = () => setStep(Step.Address);
            content = (<Fragment>
					<div className={styles.emailConsentHeader}>
						<FormattedMessage id="registration.emailConsent" defaultMessage="Email Consent"/>
					</div>
					<ProfileOkEmailInput deceased={deceased} value={value} errors={errors} backendErrors={{}} onChange={handleUpdate}/>
				</Fragment>);
            break;
        }
        case Step.Address: {
            const errors = getAddressErrors(value);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = () => setStep(isNYCZip(value) ? Step.Language : Step.Phone);
            content = (<Fragment>
					<InfoHeader />
					<ProfileAddressInputs value={value} errors={errors} backendErrors={{}} onChange={handleUpdate}/>
				</Fragment>);
            break;
        }
        case Step.Language: {
            const errors = getLanguageErrors(value);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = () => {
                if (value.languagePreference === "Spanish" && props.locale !== "es") {
                    setStep(Step.LanguageChange);
                    return;
                }
                if (value.languagePreference === "English" && props.locale !== "en") {
                    setStep(Step.LanguageChange);
                    return;
                }
                if (value.languagePreference === "English" || value.languagePreference === "Spanish") {
                    setStep(Step.Phone);
                    return;
                }
                setStep(Step.LanguageOther);
            };
            content = (<ProfileLanguageInputs value={value} onChange={handleUpdate} errors={errors}/>);
            break;
        }
        case Step.LanguageChange: {
            isValid = true;
            showRequired = false;
            handleSubmit = () => setStep(Step.Phone);
            content = (<ProfileLanguageChange language={value.languagePreference || ""}/>);
            break;
        }
        case Step.LanguageOther: {
            isValid = true;
            showRequired = false;
            handleSubmit = async () => {
                if (value.languagePreference === "Spanish" && props.locale !== "es") {
                    setStep(Step.LanguageChange);
                    return;
                }
                if (value.languagePreference === "English" && props.locale !== "en") {
                    setStep(Step.LanguageChange);
                    return;
                }
                if (value.languagePreference === "English" || value.languagePreference === "Spanish") {
                    setStep(Step.Phone);
                    return;
                }
                setLoading(true);
                await rightPartyContact({
                    address: value.address,
                    address2: value.address2,
                    city: value.city,
                    decedentRelationship: value.relationship === "" ? null : value.relationship,
                    languagePreference: value.languagePreference,
                    comments: "",
                    firstName: value.firstName,
                    lastName: value.lastName,
                    phone: null,
                    phoneType: null,
                    postalCode: value.zip,
                    probateCase: null,
                    stateProvince: value.state,
                    referenceNumber: props.referenceNumber,
                    pin: props.pin
                });
                setLoading(false);
                setStep(Step.LanguageExit);
            };
            content = (<ProfileLanguageOther onChange={handleUpdate} value={value}/>);
            break;
        }
        case Step.LanguageExit: {
            isValid = true;
            handleSubmit = () => push("/public");
            showRequired = false;
            content = (<ProfileLanguageExit />);
            break;
        }
        case Step.Phone: {
            const errors = getPhoneErrors(value);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = () => setStep(Step.SecurityQuestionAndPassword);
            content = (<Fragment>
					<InfoHeader />
					<ProfilePhoneInputs value={value} errors={errors} backendErrors={{}} onChange={handleUpdate}/>
				</Fragment>);
            break;
        }
        case Step.SecurityQuestionAndPassword: {
            showRequired = false;
            const errors = getPasswordErrors(value);
            isValid = Object.values(errors).every(it => it == null);
            handleSubmit = async () => {
                if (!value.relationship || value.okEmail == null) {
                    throw new Error("Unexpected state");
                }
                setLoading(true);
                setValidationError(null);
                setProfileError(null);
                let userResponse;
                try {
                    userResponse = await newAccount({
                        attestation: value.authorized,
                        authorizedId: value.authorizedId === -1 ? null : value.authorizedId,
                        confirmation: formatValidationData(value.validation),
                        decedentRelationship: value.relationship,
                        emailAddress: value.email,
                        firstName: value.firstName,
                        lastName: value.lastName,
                        password: value.password,
                        pin: props.pin,
                        referenceNumber: props.referenceNumber,
                        securityAnswer: value.securityAnswer,
                        securityQuestionId: parseInt(value.securityQuestion, 10),
                        channel: props.channel
                    });
                }
                catch (error) {
                    setValidationError(error);
                    setLoading(false);
                    return;
                }
                if (userResponse.data.success) {
                    setValidationFieldErrors([]);
                    try {
                        const nSessionResponse = await setupSession();
                        if (!nSessionResponse.data.success) {
                            throw new Error("Unexpected error");
                        }
                        apiService.updateXsrfToken(nSessionResponse.data.data);
                    }
                    catch (error) {
                        setLoading(false);
                        return;
                    }
                }
                else {
                    setValidationFieldErrors(fieldErrorsBackToFront(userResponse.data.errors));
                    setLoading(false);
                    return;
                }
                let profileResponse;
                try {
                    profileResponse = await create({
                        address: value.address,
                        address2: value.address2,
                        canSendCollectionEmail: value.okEmail,
                        cellPhone: value.phoneCell,
                        city: value.city,
                        firstName: value.firstName,
                        homePhone: value.phoneHome,
                        lastName: value.lastName,
                        postalCode: value.zip,
                        preferredPhone: value.preferredPhone,
                        stateProvince: value.state,
                        workPhone: value.phoneWork,
                        workPhoneExtension: value.phoneWork,
                        languagePreference: value.languagePreference
                    });
                }
                catch (error) {
                    setProfileError(error);
                    setLoading(false);
                    return;
                }
                if (profileResponse == null) {
                    throw new Error("Unexpected state");
                }
                if (profileResponse.data.success) {
                    setProfileFieldErrors([]);
                    setLoading(false);
                    props.onSuccess(userResponse.data.data, profileResponse.data.data);
                }
                else {
                    setProfileFieldErrors(fieldErrorsBackToFront(profileResponse.data.errors));
                    setLoading(false);
                }
            };
            submitLabel = messages.submit;
            content = (<div>
					<div className="passwordContent">
						<div className="vr vr_x5">
							<PasswordCreateInputs value={value} errors={errors} backendErrors={backendErrors} locale={props.locale} securityQuestions={props.securityQuestions} onChange={handleUpdate}/>
						</div>

						<div>
							<div className="vr vr_x2">
								<h2 className="label">
									<FormattedMessage id="passwordCreate.requirements.header" defaultMessage="Password requirements:"/>
								</h2>
							</div>
							<div className="vr vr_x5">
								<div className="text">
									<Requirements className="listV listV_x3 mix-listV_bullet"/>
								</div>
							</div>
						</div>
					</div>

					<div className="text">
						<FormattedMessage id="createProfile.consent" defaultMessage="By clicking Create Profile, you consent to receive a one-time Profile Created email to {email}." values={{
                email: value.email
            }} tagName="p"/>
					</div>
				</div>);
            break;
        }
    }
    return (<Fragment>
			{step !== Step.Intro && (<div className={styles.wrapper}>
					<div className="vr vr_x5">
						<StepProgress {...stepProgress}/>
					</div>
				</div>)}

			<div className={step === Step.SecurityQuestionAndPassword ? styles.wrapper : "wrapper wrapper_narrow"}>
				<div className="mix-content_centerText">
					<StatusMessage isError isActive={validationError != null} error={validationError} customMessage={VALIDATION.INTRO_VALIDATION_ERROR} domain="validation"/>

					<StatusMessage isError isActive={profileError != null} error={profileError} customMessage={PROFILE.CREATE_ERROR_INTRO} domain="profile"/>
				</div>

				<div className="vr vr_x5">
					<Form className={styles.form} isBusy={loading} isValid={isValid} onSubmit={handleSubmit} submitLabel={submitLabel} error={globalError} hideRequiredMessage key={step} // re-render when step changes to ensure focus resets
    >
						{content}
						{showRequired && (<RequiredMessage className={styles.required}/>)}
					</Form>
				</div>

				<div className="mix-content_centerText">
					<StatusMessage isActive={loading} isLoad/>
				</div>

				<div className="vr vr_x5 mix-content_centerText">
					<div className="text">
						<FormattedMessage tagName="p" id="registration.help" defaultMessage="Need help? {contactLink}." values={{
        contactLink: (<Link className="link" to="/public/contact">
										<FormattedMessage id="registration.help.contactLink" defaultMessage="Contact us"/>
									</Link>)
    }}/>
					</div>
				</div>
			</div>
		</Fragment>);
}
export default track({ page: "Registration" }, { dispatchOnMount: true })(connect((state) => ({
    pin: state.validation.validationRequest.pin,
    referenceNumber: state.validation.validationRequest.referenceNumber,
    deceased: state.validation.deceased,
    decedent: state.validation.decedent,
    securityQuestions: state.auth.questions,
    locale: state.i18n.locale,
    authIndividuals: state.validation.authorized || [],
    validationQuestions: state.validation.confirmation || [],
    channel: state.validation.registrationChannel ?? RegistrationChannel.Unknown
}), {
    onSuccess: registrationComplete
})(RegistrationBase));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Registration/Registration.tsx